<template>

<app-page v-if="is.loaded" :title="text.title" :loading="is.verifying">

	<app-inner :row="!window.is.mobile" :condensed="true" v-if="!is.verifying">

		<app-column>

			<app-text>

				<h2>{{ text.login_title }}</h2>

				<p>{{ text.login_description }}</p>

				<app-message :error="true" v-if="is.errored">

					Sorry, your details were not recognised. Please check and try again.

				</app-message>

				<app-group>

					<app-input-text v-model="inputs.email" :errored="errored.email" :placeholder="text.login_email_placeholder" />
					<app-input-password v-model="inputs.password" :errored="errored.password" :placeholder="text.login_password_placeholder" />

				</app-group>

				<app-group :row="true">

					<app-button :text="text.login_button_submit" :loading="is.submitting" :disabled="!is.valid" v-on:click="onLoginClick" />

					<app-button v-if="isContextCustomer" to="Login/Customer/Forgot" :text="text.login_button_forgot" theme="plain" />
					<app-button v-if="isContextBusiness" to="Login/Business/Forgot" :text="text.login_button_forgot" theme="plain" />

				</app-group>

				<app-group v-if="isContextCustomer">

					<app-button v-if="page.oauth_facebook" :href="page.oauth_facebook" icon="facebook" :text="text.login_button_facebook" theme="facebook" />
					<app-button v-if="page.oauth_twitter" :href="page.oauth_twitter" icon="twitter" :text="text.login_button_twitter" theme="twitter" />

				</app-group>

			</app-text>

		</app-column>

		<app-column>

			<app-text>

				<h2>{{ text.join_title }}</h2>

				<p>{{ text.join_description }}</p>

				<app-group :row="true">

					<app-button v-if="isContextCustomer" to="Register/Customer" :query="$route.query" :text="text.join_button_submit" />
					<app-button v-if="isContextBusiness" to="Listing" :text="text.join_button_submit" />

				</app-group>

			</app-text>

		</app-column>

	</app-inner>

</app-page>

</template>

<script>

import mixinPage from '@/mixin/page.js'
import mixinForm from '@/mixin/form.js'

export default {

	mixins: [mixinPage, mixinForm],

	data: function() {

		return {
			is: {
				verifying: false
			},
			inputs: {
				email: '',
				password: ''
			},
			rules: {
				email: {
					required: true
				},
				password: {
					required: true
				}
			}
		}

	},

	computed: {

		text: function() {

			var text = {}

			this.$_.each(this.page, function(value, key) {

				if (this.isContextCustomer && key.indexOf('customer_') === 0) {

					text[key.replace('customer_', '')] = value

				} else if (this.isContextBusiness && key.indexOf('business_') === 0) {

					text[key.replace('business_', '')] = value

				}

			}.bind(this))

			return text

		}

	},
	
	created: function() {

		if (this.$route.meta.facebook) {

			this.verifyFacebook()

		} else if (this.$route.meta.twitter) {

			this.verifyTwitter()

		}

	},

	methods: {

		verifyFacebook: function() {

			this.is.verifying = true

			this.$api.request('login/facebook', {
				state: this.$route.query.state,
				code: this.$route.query.code,
				url: window.location.href
			}).then(function() {

				this.$router.push({
					name: 'Dashboard'
				})

			}.bind(this), function() {

				this.is.verifying = false

				this.$router.replace({
					name: 'Login/Customer'
				})

			}.bind(this))

		},

		verifyTwitter: function() {

			this.is.verifying = true

			this.$api.request('login/twitter', {
				oauth_verifier: this.$route.query.oauth_verifier
			}).then(function() {

				this.$router.push({
					name: 'Dashboard'
				})

			}.bind(this), function() {

				this.is.verifying = false

				this.$router.replace({
					name: 'Login/Customer'
				})

			}.bind(this))

		},

		onLoginClick: function() {

			this.save('login', {
				context: this.context,
				email: this.inputs.email,
				password: this.inputs.password
			}).then(function() {

                if (this.$route.query.redirect) {

                    this.$router.push({
                        path: this.$route.query.redirect
                    })
                    
                } else {

                    this.$router.push({
                        name: 'Dashboard'
                    })

                }

			}.bind(this))

		}

	}

}

</script>